import {Breakpoint} from './Breakpoint';

/**
 * Mobile-first responsive value type
 * Allows specifying different values for different breakpoints
 * @example { base: 2, sm: 3, lg: 5 } → p-2 sm:p-3 lg:p-5
 * @example { base: 'column', lg: 'row' } → flex-col lg:flex-row
 */
export type ResponsiveValue<T> = Partial<Record<Breakpoint, T>>;

/**
 * Type guard to check if a value is a responsive object
 */
export const isResponsiveValue = <T>(
  value: T | ResponsiveValue<T>
): value is ResponsiveValue<T> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
};
